const apiUrl = process.env.REACT_APP_AZURE_URL_API;
const ocpKey = process.env.REACT_APP_AZURE_OCP_KEY;
const apiUrlToken = process.env.REACT_APP_AZURE_URL_TOKEN;
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID;
const clientSecret = process.env.REACT_APP_AZURE_CLIENT_SECRET;
const scope = process.env.REACT_APP_AZURE_SCOPE;

export const protectedResources = {
    apiDenuncia: {
        suscription: ocpKey,
        endpoint: apiUrl,
        endpointToken: apiUrlToken,
        clientId: clientId,
        clientSecret: clientSecret,
        scope: scope
    }
}